if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.dismissOthers();
      if (!this.dataset.productTitle || this.dataset.productTitle === 'undefined') this.dataset.productTitle = '';
      this.setProductTitle(this.dataset.productTitle);
      this.setImageAndVariant();
      this.display();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) {
          notification.dismiss();
        }
      });
    }

    setProductTitle(productTitle) {
      this.querySelector('.added-notification__message-title').innerText = productTitle;
    }

    setImageAndVariant() {
      const imageWrap = this.querySelector('.added-notification__image');
      if (imageWrap && this.dataset.image) {
        const img = document.createElement('img');
        img.src = this.dataset.image + (this.dataset.image.includes('?') ? '&' : '?') + 'width=160';
        img.alt = '';
        imageWrap.appendChild(img);
      }
      const variant = this.querySelector('.added-notification__variant');
      if (variant && this.dataset.variantTitle) variant.innerText = this.dataset.variantTitle;
    }

    display() {
      // reveal
      setTimeout(() => this.classList.remove('added-notification--hidden'), 10);

      // dismiss after a short period of time
      this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), 3000);

      // add events to internal links
      this.querySelector('.added-notification__close').addEventListener('click', this.dismiss.bind(this));
      if (theme.settings.cartType === 'drawer') {
        const cartLinks = this.querySelectorAll('.added-notification__message-text a[href$="/cart"]');
        cartLinks.forEach((el) => {
          el.addEventListener('click', (evt) => {
            evt.preventDefault();
            document.querySelector('.js-cart-drawer').open(evt.currentTarget);
            this.dismiss();
          });
        });
      }
    }

    dismiss(evt) {
      if (evt) { evt.preventDefault(); }
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 400);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
